import { Event, EventListener } from "../../events/Event";
import { Map } from "./Map";
import { MapPin } from "./MapPin";

export interface PinPlotListener extends EventListener<PinPlotEvent> {
}

export class PinPlotEvent extends Event<Map> {
    private _pin: MapPin;

    constructor(map: Map, pin: MapPin) {
        super(map);
        this._pin = pin;
    }

    get pin(): MapPin {
        return this._pin;
    }
}
